"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CommentCreateWrapper = function CommentCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "commentText", _descriptor, _this);
      _initializerDefineProperty(_this, "initialText", _descriptor2, _this);
      _initializerDefineProperty(_this, "suggestedText", _descriptor3, _this);
      _initializerDefineProperty(_this, "caretPosition", _descriptor4, _this);
      _initializerDefineProperty(_this, "postAsUser", _descriptor5, _this);
      if (_this.props.text) {
        _this.setInitialText(_this.props.text);
      }
      _this.applySuggestedText(_this.props.suggestedText);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disable",
      get: function get() {
        return this.commentText === this.initialText;
      }
    }, {
      key: "id",
      get: function get() {
        if (this.props.commentable) {
          return "comment-create-input-".concat(this.props.commentable.id);
        } else {
          return 'comment-create-input';
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.text && prevProps.text !== this.props.text) {
          this.setInitialText(this.props.text);
        }
        if (this.props.suggestedText && prevProps.suggestedText !== this.props.suggestedText) {
          this.applySuggestedText(this.props.suggestedText);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.xpState.clearXpAnimationNamespace(this.props.namespace);
      }
    }, {
      key: "onChangeComment",
      value: function onChangeComment(value, caretPosition) {
        this.commentText = value;
        this.caretPosition = caretPosition;
      }
    }, {
      key: "setInitialText",
      value: function setInitialText(text) {
        this.initialText = text;
        this.commentText = text;
      }
    }, {
      key: "applySuggestedText",
      value: function applySuggestedText(text) {
        var _this$commentText;
        if (((_this$commentText = this.commentText) !== null && _this$commentText !== void 0 ? _this$commentText : '') === '' && text) {
          this.commentText = text;
        }
      }
    }, {
      key: "onSubmit",
      value: function onSubmit() {
        if (!_state.AppUI.layout.isNative && this.props.namespace && !this.props.edit) {
          setTimeout(this.showAnimation, 50);
        }
        if (this.props.onSubmitComment) {
          this.props.onSubmitComment(this.commentText);
        } else {
          if (_state.DeckUI.currentCard && _state.DeckUI.currentCard.sentence) {
            _state.DeckUI.currentCard.sentence.set('commentsCount', _state.DeckUI.currentCard.sentence.commentsCount + 1);
          }
          if (_state.DeckUI.currentCard && _state.DeckUI.currentCard.word) {
            _state.DeckUI.currentCard.word.set('commentsCount', _state.DeckUI.currentCard.word.commentsCount + 1);
          }
          _state.ForumUI.onCreateComment({
            userId: this.postAsUser ? this.postAsUser.id : null,
            commentableId: this.props.commentable ? this.props.commentable.id : this.props.commentableId,
            parentId: this.props.parentId,
            commentableType: this.props.commentableType,
            text: this.commentText,
            wordId: this.props.wordId,
            conceptId: this.props.conceptId,
            faqItemId: this.props.faqItemId,
            sentenceId: this.props.sentenceId,
            debugInfo: this.props.debugInfo
          }, this.afterCreateComment);
          this.onResetComment();
          if (this.props.afterSubmitComment) {
            this.props.afterSubmitComment();
          }
        }
      }
    }, {
      key: "afterCreateComment",
      value: function afterCreateComment(resp) {
        _state.ForumUI.onAfterCreateComment(resp);
        if (this.props.afterCreateComment) {
          this.props.afterCreateComment(resp);
        }
      }
    }, {
      key: "showAnimation",
      value: function showAnimation() {
        _state.AppUI.createXpAnimation({
          type: 'chat-message',
          xp: 2,
          namespace: this.props.namespace
        });
      }
    }, {
      key: "onResetComment",
      value: function onResetComment() {
        this.commentText = this.props.edit ? this.props.text : '';
        this.initialText = this.commentText;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          disable: this.disable,
          id: this.id,
          commentText: this.commentText,
          initialText: this.initialText,
          caretPosition: this.caretPosition,
          postAsUser: this.postAsUser,
          onChangeComment: this.onChangeComment,
          setInitialText: this.setInitialText,
          insertText: this.insertText,
          onSubmit: this.onSubmit,
          showAnimation: this.showAnimation,
          onResetComment: this.onResetComment
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "commentText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "suggestedText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "caretPosition", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "postAsUser", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "disable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disable"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "id", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "id"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeComment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setInitialText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setInitialText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "applySuggestedText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "applySuggestedText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateComment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAnimation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "showAnimation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onResetComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onResetComment"), _class2.prototype), _class2)) || _class;
};
CommentCreateWrapper.displayName = 'CommentCreateWrapper';
var _default = exports["default"] = CommentCreateWrapper;